import { Linking } from "react-native";
import { loaderModal } from "../AlertLoaderService";
import { doPost as aayuDoPost } from "../api/API";


export async function getChemistSiteUrl(pharmacy) {
    loaderModal.setLoader(true)
    var params = { pharmacyId: pharmacy.id }
    await aayuDoPost('accounts/get_chemist_site_url', params).then(
        (response: any) => {
            loaderModal.setLoader(false)
            if (response && response['redirectUrl'])
                Linking.openURL(response['redirectUrl']).catch((err) =>
                    console.error('An error occured', err));
        }, (err: any) => {
            loaderModal.setLoader(false);
            console.log("API is failed with error " + err)
        }
    )

}